import { z } from 'zod'

export const datetimeSchema = z
  .string()
  .transform((date) => {
    // Convert YYYY-MM-DD to YYYY-MM-DDT00:00:00.000Z
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return `${date}T00:00:00.000Z`
    }
    if (!date.endsWith('Z')) {
      return `${date}Z`
    }
    return date
  })
  .pipe(z.iso.datetime({ offset: true }).transform((date) => new Date(date)))
